import { TypeScriptEmitter } from '@angular/compiler';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vision-mision',
  templateUrl: './vision-mision.component.html',
  styles: [
  ]
})
export class VisionMisionComponent implements OnInit {

  @Input() borderTop = true;
  @Input() dataVisi;
  @Input() dataMisi;

  constructor() { }

  ngOnInit(): void {
  }

}
